import React from 'react';
import {Alert, AlertTitle, Snackbar} from "@mui/material";

// severity: "success" | "info" | "warning" | "error"
const AlertSnackbar = ({open, severity, title, message, onClose}) => {
    return (
        <Snackbar open={open} /*autoHideDuration={3000}*/ anchorOrigin={{vertical: 'top', horizontal: 'right'}} onClose={onClose}>
            <Alert
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {title && <AlertTitle>{title}</AlertTitle>}
                {message}
            </Alert>
        </Snackbar>
    );
};

export default AlertSnackbar;